<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-12-15 18:15:58
-->
<template>
  <RibbonButton
    :size="size"
    :class="['component--ribbon__check', isChecked ? 'checked' : null]"
    :disabled="disabled"
    :label="label"
    :icon="icon"
    :iconClass="iconClass"
    @click="handleClick"
    :title="titleText"
  >
    <template v-if="$slots.default" slot="icon">
      <slot></slot>
    </template>
  </RibbonButton>
</template>

<script>
import RibbonButton from "./ribbonButton.vue";
import ShortcutBase from "./shortcutBase";
export default {
  props: {
    icon: {
      type: String,
    },
    iconClass: {
      type: String,
    },
    label: {
      type: String,
    },
    size: {
      type: String,
      default: "large",
    },
    trueValue: {
      type: [Boolean, Number, String],
      default: true,
    },
    falseValue: {
      type: [Boolean, Number, String],
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Boolean, Number, String],
      default: false,
    },
    title: String,
  },
  components: {
    RibbonButton,
  },
  mixins: [ShortcutBase],
  data() {
    return {
      isChecked: this.value == this.trueValue,
    };
  },
  computed: {
    shortcutHandler() {
      return this.handleClick;
    },
    titleText() {
      return this.title || this.shortcutTitle;
    },
  },
  methods: {
    handleClick(ev) {
      if (this.readonly) return;
      this.isChecked = !this.isChecked;
      this.$emit("click");
    },
  },
  watch: {
    value(newValue) {
      this.isChecked = newValue === this.trueValue;
    },
    isChecked(newValue) {
      this.$emit("input", newValue ? this.trueValue : this.falseValue);
      this.$emit("change", newValue);
    },
  },
};
</script>

<style lang="scss">
.component--ribbon__check {
  border: 1px solid transparent;

  &.checked {
    border-color: #409eff6b;
    background: #409eff3d;

    &:hover {
      border-color: #409eff3b;
      background: #409eff1d;
    }
  }
}
</style>